import AppModel from '@/models/AppModel'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  apiSetStore: (bvModal, params, callback) => {
    return AppModel.post('log/chime', bvModal, params, (res) => {
      if (isDebug) {
        console.log(res.data)
      }

      AppModel.validateStatus(res.data)

      return Promise.resolve(res.data)
    }, null, callback)
  }
}



// WEBPACK FOOTER //
// ./src/models/ChimeLogModel.js